import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { ForosService } from 'src/app/services/foros.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-atualiza-foros',
    templateUrl: './modal-atualiza-foros.component.html',
    providers: [ForosService]
})

export class ModalAtualizaForosComponent implements OnInit {

    modalRef: NgbModalRef;
    public foro: any;
    public listaEstados = [];

    constructor(
        private appService: AppService,
        private forosService: ForosService,
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private dadosCargasService: DadosCargasService
    ) { }

    ngOnInit(): void {
        this.foro = this.modalRef.componentInstance.foro;
        this.listaEstados = this.dadosCargasService.mockEstados();
    }

    atualizar() {
        this.update(this.foro);
    }

    update(foro) {
        this.spinner.show();
        this.toastrService.clear();

        this.forosService.update(foro)
            .subscribe(res => {
                this.toastrService.success("Foro atualizado!.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'atualizado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível atualizar o foro!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}

